export const seriesNameFormatter = (seriesName: string): string => (seriesName === 'other' ? 'Others' : seriesName);
